import { render, staticRenderFns } from "./cABasicTab.vue?vue&type=template&id=99d71196&"
import script from "./cABasicTab.vue?vue&type=script&lang=js&"
export * from "./cABasicTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d71196')) {
      api.createRecord('99d71196', component.options)
    } else {
      api.reload('99d71196', component.options)
    }
    module.hot.accept("./cABasicTab.vue?vue&type=template&id=99d71196&", function () {
      api.rerender('99d71196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/ClosingAccount/cABasicTab.vue"
export default component.exports